import React, { Fragment } from "react";
import PropTypes from 'prop-types';
import { Col, Container, Row } from "react-bootstrap";
import { lighten, darken, makeStyles } from "@material-ui/core/styles";
import { Button } from "@material-ui/core";
import "./SolutionArticleDetail.scss";

export default function SolutionArticleDetail(props) {

  const { items } = props.data;

  const useStyles = makeStyles(theme => ({
    backgroundColor: {
      backgroundColor: lighten(theme.palette.primary.main, 0.92),
    },
    cardImage: {
      backgroundImage: `url("")`,
      backgroundRepeat: "no-repeat",
      backgroundSize: "cover"
    },
    textColor: {
      color: theme.palette.primary.main,
    },
    buttonColorDark: {
      height: 36,
      fontSize: "0.875rem",
      fontWeight: 700,
      letterSpacing: "1.4px",
      backgroundColor: theme.palette.primary.main,
      color: "#fff",
      '&:hover': {
        color: "#fff",
        backgroundColor: darken(theme.palette.primary.main, 0.2),
      },
      '&:focus': {
        color: "#fff",
        backgroundColor: darken(theme.palette.primary.main, 0.2),
        outline: "none"
      }
    },
    buttonColorLight: {
      height: 36,
      fontSize: "0.875rem",
      fontWeight: 700,
      letterSpacing: "1.4px",
      color: theme.palette.primary.main ,
      backgroundColor:  "#fff",
      border: "none",
      boxShadow: "0 1px 3px rgba(0,0,0,0.3)",
      '&:hover': {
        color: theme.palette.primary.main,
        backgroundColor: lighten(theme.palette.primary.main, 0.9),
      },
      '&:focus': {
        color: "#fff",
        backgroundColor: lighten(theme.palette.primary.main, 0.2),
        outline: "none"
      }
    }
  }));

  const classes = useStyles();

  return (
    <Fragment>
      {items.map((item, index) => 
        <Row id={item.anchor} key={index} className={`article-detail-container ${item.backgroundContrast ? classes.backgroundColor : ""}`}>
          <Col>
            <div className="image-container">
              <img src={item.image} alt=""/>
            </div>
          </Col>
          <Col>
            <Row className="section-content-container">
              <div className="section-content">
                <h2>{item.title}</h2>
                {item.section.map((section, index) => <div key={index} className="section-group">
                  <h3>{section.title}</h3>
                  {section.paragraphs.map((p, index) => <p key={index}>{p}</p>)}
                </div>)}
              </div>
              <div className="action-container">
              {item.callToAction.map((item, index) => 
                  <Button 
                    key={index} 
                    variant="contained" 
                    href={item.href ? item.href : item.productType === "term" ? props.journeys.termJourney : props.journeys.americoJourney } 
                    size="large" 
                    className={`btn-sm ${item.buttonLight ? classes.buttonColorLight : classes.buttonColorDark}`}
                    onClick={undefined}>{item.buttonTitle}</Button>)
              }
            </div>
            </Row>
          </Col>
        </Row>
        )}
    </Fragment>
  )
}

SolutionArticleDetail.propType = {
  data: PropTypes.shape({
    items: PropTypes.array,
  })
}


// WEBPACK FOOTER //
// ./src/components/LandingPages/SolutionsArticleDetail/SolutionArticleDetail.js